import { render, staticRenderFns } from "./ProductSelectSize.vue?vue&type=template&id=43b8bb1b&scoped=true"
import script from "./ProductSelectSize.vue?vue&type=script&lang=ts"
export * from "./ProductSelectSize.vue?vue&type=script&lang=ts"
import style0 from "./ProductSelectSize.vue?vue&type=style&index=0&id=43b8bb1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b8bb1b",
  null
  
)

export default component.exports